var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 0.199951H16.0004V3.79995H10.0004V18.2H6.40039V3.79995H0.400391V0.199951ZM11.2004 4.99995H13.6004V7.39995H11.2004V4.99995ZM14.8004 4.99995H17.2004V7.39995H14.8004V4.99995ZM18.4004 4.99995H20.8004V7.39995H18.4004V4.99995ZM11.2004 8.59995H13.6004V11H11.2004V8.59995ZM11.2004 12.2H13.6004V14.6H11.2004V12.2ZM11.2004 15.8H13.6004V18.2H11.2004V15.8ZM11.2004 19.4H13.6004V21.8H11.2004V19.4Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTextIcon);
export default __webpack_public_path__ + "static/media/add-text-icon.a343174b6dae1b5a2bdd8f90bf3a3018.svg";
export { ForwardRef as ReactComponent };